import React from 'react'
import styled from '@emotion/styled'
import { OopsIcon } from 'src/components/icons/oops'
import { Colors } from 'src/components/theme'

type ListEmptyStateProps = {
  heading?: React.ReactNode
  subheading?: React.ReactNode
}

const EmptyStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 69px 0px;

  & span {
    font-size: 14px;
    margin-top: 12px;
    color: ${Colors.textLight};
  }
`

const Subheading = styled.span`
  width: 250px;
  text-align: center;
`

export const ListEmptyState: React.FC<ListEmptyStateProps> = ({ heading = "There's nothing here yet", subheading }) => {
  return (
    <EmptyStateWrapper>
      <OopsIcon size={50} color={Colors.neutral300} />
      <span>{heading}</span>
      {subheading && <Subheading>{subheading}</Subheading>}
    </EmptyStateWrapper>
  )
}
